import {
	applyMuted,
	playSound,
	Sound,
	sounds,
	stopSound,
} from '~/assets/sounds';
import type { IObservable } from '~/rage/utils';
import type { IRpcPlaySoundPayload, IRpcStopSoundPayload } from '~/shared';
import type { IRpcService } from '../RpcService';
import type { VarsService } from '../VarsService';
import type { ISoundsService } from './soundsServiceTypes';

const soundValues = new Set<string>(Object.values(Sound));

function isValidSoundId(id: string): id is Sound {
	return soundValues.has(id) && id in sounds;
}

export class SoundsService implements ISoundsService {
	constructor(
		rpc: IRpcService,
		private readonly vars: VarsService,
	) {
		rpc.register<IRpcPlaySoundPayload>('sounds:play', (payload) => {
			const id = payload.sound;

			if (!isValidSoundId(id)) {
				return;
			}

			playSound(id, payload.volume ?? 1);
		});

		rpc.register<IRpcStopSoundPayload>('sounds:stop', (payload) => {
			const id = payload.sound;

			if (!isValidSoundId(id)) {
				return;
			}

			stopSound(id);
		});

		this.vars.get<boolean>('sound:muted', false).subscribe((value) => {
			applyMuted(!!value);
		});
	}

	public getMutedObservable(): IObservable<boolean> {
		return this.vars.get<boolean>('sound:muted', false);
	}

	public toggleMuted(): void {
		const current = this.vars.get<boolean>('sound:muted', false).getValue();
		this.vars.set('sound:muted', !current);
	}
}
